import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { FORM_ERROR } from 'final-form'

import LoginForm from './LoginForm'
import {
  signIn,
  redirect,
  appleAuth,
  fbAuth,
  isSuccessful,
  needsConfirmation,
} from '../../services'

class LoginFormContainer extends PureComponent {
  static propTypes = {
    onConfirmationRequired: PropTypes.func.isRequired,
    onLogIn: PropTypes.func,
    afterAuthAction: PropTypes.func,
    nextPage: PropTypes.string,
  }

  state = { thirdPartyError: '' }

  handleSubmit = async (values) => {
    const { nextPage, afterAuthAction, onLogIn } = this.props
    try {
      const res = await signIn({ ...values, nextPage })
      if (afterAuthAction) {
        afterAuthAction(res)
      }
      redirect(res, onLogIn)
      return {}
    } catch (error) {
      if (error.statusCode === 422) {
        if (error.status === 'sso_only_error') {
          const encodedEmail = encodeURIComponent(values.email)
          window.location.href = `/auth/auth0?login=prompt&login_hint=${encodedEmail}`
          return {}
        }
      } else if (error.statusCode === 429) {
        return {
          [FORM_ERROR]:
            'Due to multiple failed login attempts, your account has been temporarily locked for 2 hours.',
        }
      }
      return { [FORM_ERROR]: 'Your email or password are incorrect' }
    }
  }

  handleFacebookResponse = (res) => {
    const { afterAuthAction, onLogIn, onConfirmationRequired } = this.props
    if (isSuccessful(res)) {
      if (afterAuthAction) {
        afterAuthAction(res, 'facebook')
      }

      redirect(res, onLogIn)
    } else if (needsConfirmation(res)) {
      onConfirmationRequired(res)
    }
  }

  appleLogin = (data) => {
    appleAuth(data)
      .then((res) => {
        redirect(res, this.props.onLogIn)
      })
      .catch((err) => {
        if (err.email) {
          this.setState({
            thirdPartyError:
              'You need to create an account on our iOS app first.',
          })
        } else {
          this.setState({
            thirdPartyError:
              'Sorry, something went wrong. Please try again or email support@masterclass.com.',
          })
        }
      })
  }

  facebookLogin = () =>
    fbAuth()
      .then(this.handleFacebookResponse)
      .catch((err) => {
        this.setState({ thirdPartyError: err.message })
      })

  render() {
    return (
      <LoginForm
        onSubmit={this.handleSubmit}
        facebookLogin={this.facebookLogin}
        appleLogin={this.appleLogin}
        thirdPartyError={this.state.thirdPartyError}
        {...this.props}
      />
    )
  }
}

export default LoginFormContainer
